!function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){t.exports=n(1)},function(t,e,n){"use strict";function o(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:75e3;return new Promise((function(n){var o=setInterval((function(){t()&&(n(t()),clearInterval(o),o=null)}),500);setTimeout((function(){null!==o&&(clearInterval(o),console.log("condition false"))}),e)}))}n.r(e);var i={collectionPage:'section[data-section-type="collection"] #our-offers',atcOption:".PT242__OptionWidget .PT242__OptionWidget--Options .PT242__OptionWidget--Option",productsWrapper:".CollectionInner__Products .ProductListWrapper > .ProductList"};(function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"v1";window.optiActiveTests=window.optiActiveTests||{},window.optiActiveTests[t]=e})("OP_PT_351","v1"),o((function(){return null!==document.querySelector(i.collectionPage)&&document.body.classList.contains("PT_242")})).then((function(){document.body.classList.add("pt_351"),o((function(){return document.querySelectorAll(i.atcOption).length>0})).then((function(){document.querySelectorAll(i.atcOption).forEach((function(t){var e=t.classList.contains("PT242__OptionWidget--Onetime"),n=t.classList.contains("PT242__OptionWidget--Subscription");t.classList.toggle("PT242__OptionWidget--Active",!e||n)})),document.querySelector(i.productsWrapper).addEventListener("click",(function(t){var e=t.target,n=e.closest(".ProductItem");e.classList.contains("PT242__Button--addToCart")&&(n.querySelector(".PT242__OptionWidget--Subscription").click(),n.querySelector(".PT242__OptionWidget--Subscription--Options").selectedIndex=0)}))}))}))}]);
document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".ProductItem");
  productCards.forEach(function (card) {
    const addToCartButton = card.querySelector(".PT242__Button--addToCart");
    const optionWidget = card.querySelector(".PT242__OptionWidget");
    const overlay = card.querySelector(".PT242__Overlay");
    const closeButton = optionWidget?.querySelector(".PT242__OptionWidget--Close");
    const onetimeOption = optionWidget?.querySelector(".PT242__OptionWidget--Onetime");
    const subscriptionOption = optionWidget?.querySelector(".PT242__OptionWidget--Subscription");
    const addToCartConfirmButton = optionWidget?.querySelector(".PT242__OptionWidget--Button");
    const subscriptionSelect = optionWidget?.querySelector(".PT242__OptionWidget--Subscription--Options");
    const toggleOneTime = optionWidget?.querySelector(".pt_413_toggle_input_one_time");
    const toggleSubscription = optionWidget?.querySelector(".pt_413_toggle_input_subscription");
    const onetimeWrapper = optionWidget?.querySelector(".pt_413_onetime_wrapper");
    const subscriptionWrapper = optionWidget?.querySelector(".pt_413_subscription_wrapper");
    const onetimeLeftLowerCTA = card.querySelector(".pt_413_onetime_left_lower_cta");
    const variantId = addToCartButton?.getAttribute("data-var_id");
    if (!addToCartButton || !optionWidget) return;

    addToCartButton.addEventListener("click", function (e) {
      closeAllPopups();
      optionWidget.style.display = "block";
      overlay.style.display = "block";
    });
    closeButton?.addEventListener("click", function () {
      optionWidget.style.display = "none";
      overlay.style.display = "none";
    });
    overlay?.addEventListener("click", function () {
      optionWidget.style.display = "none";
      overlay.style.display = "none";
    });
    document.addEventListener("click", function (e) {
      if (!optionWidget.contains(e.target) && !addToCartButton.contains(e.target) && !overlay.contains(e.target)) {
        optionWidget.style.display = "none";
      overlay.style.display = "none";
      }
    });
    function closeAllPopups() {
      document.querySelectorAll(".PT242__OptionWidget").forEach(function (popup) {
        popup.style.display = "none";
      });
      document.querySelectorAll(".PT242__Overlay").forEach(function (overlay) {
        overlay.style.display = "none";
      });
    }
     
    function updateButtonPrice(price) {
      if (addToCartConfirmButton) {
        const priceElement = addToCartConfirmButton.querySelector(".PT242__OptionWidget--ButtonPrice");
        if (priceElement) {
          priceElement.textContent = price;  // Update the price displayed on the button
        }
      }
    }
    toggleOneTime?.addEventListener("click", function () {
      subscriptionOption?.classList.add("PT242__OptionWidget--Active");
      onetimeOption?.classList.remove("PT242__OptionWidget--Active");
      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      const subscriptionPrice = subscriptionOption?.getAttribute("optionprice"); // Get the price from option
      if (subscriptionPrice) {
        updateButtonPrice(subscriptionPrice);
      }
    });
    toggleSubscription?.addEventListener("click", function () {
      onetimeOption?.classList.add("PT242__OptionWidget--Active");
      subscriptionOption?.classList.remove("PT242__OptionWidget--Active");
      subscriptionWrapper?.classList.add("pt_413_hidden");
      onetimeWrapper?.classList.remove("pt_413_hidden");
      const oneTimePrice = onetimeOption?.getAttribute("optionprice"); // Get the price from option
      if (oneTimePrice) {
        updateButtonPrice(oneTimePrice);
      }
    });
    onetimeLeftLowerCTA?.addEventListener("click", function () {
      subscriptionOption?.classList.add("PT242__OptionWidget--Active");
      onetimeOption?.classList.remove("PT242__OptionWidget--Active");

      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      const subscriptionPrice = subscriptionOption?.getAttribute("optionprice"); // Get the price from option
      if (subscriptionPrice) {
        updateButtonPrice(subscriptionPrice);
      }
    });
    
    addToCartConfirmButton?.addEventListener("click", function (e) {
      e.preventDefault();

      const currentVariantId = addToCartConfirmButton.getAttribute("data-variant-id");
      if (!currentVariantId) {
        console.error('No variant ID found!');
        return;
      }

      const isSubscription = subscriptionOption?.classList.contains("PT242__OptionWidget--Active");
      let sellingPlanId = "";

      if (isSubscription && subscriptionSelect) {
        sellingPlanId = subscriptionSelect.value;
      }
      console.log(sellingPlanId);

      const formData = {
        items: [{
          id: currentVariantId,
          quantity: 1,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(data => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
        $('.cart_dr')[0].click();
        optionWidget.style.display = "none";
        overlay.style.display = "none";
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Sorry, could not add product to cart.');
      });
    });
  });
});